import { useTranslation } from 'react-i18next';
import { LiliBadge, LiliBadgeType } from '@lili/lili-frontend-common';
import { INVOICE_STATUS_GROUP_MAPPING } from '../../consts/consts';
import Icon from '../../../../../generic-components/Icon';
import { bluePaperPlaneIcon, greenCheckMarkIcon } from '../../../../../assets/svg';

interface StatusBadgeProps {
  status: string;
}

export const InvoicesStatusBadge = ({ status }: StatusBadgeProps) => {
  const { t } = useTranslation();

  const getStatusBadgeText = () => {
    if (INVOICE_STATUS_GROUP_MAPPING.SENT.includes(status)) return t('INVOICES_TABLE.STATUS_BADGES.SENT');
    if (INVOICE_STATUS_GROUP_MAPPING.UNSENT.includes(status)) return t('INVOICES_TABLE.STATUS_BADGES.CREATED');
    if (INVOICE_STATUS_GROUP_MAPPING.PAID.includes(status)) return t('INVOICES_TABLE.STATUS_BADGES.PAID');
    if (INVOICE_STATUS_GROUP_MAPPING.CANCELED.includes(status)) return t('INVOICES_TABLE.STATUS_BADGES.CANCELED');
    return '';
  };

  const getIcon = () => {
    let src = null;
    if (INVOICE_STATUS_GROUP_MAPPING.SENT.includes(status)) src = bluePaperPlaneIcon;
    if (INVOICE_STATUS_GROUP_MAPPING.PAID.includes(status)) src = greenCheckMarkIcon;
    if (src) {
      return <Icon src={src} />;
    }
    return null;
  };

  const getType = () => {
    if (INVOICE_STATUS_GROUP_MAPPING.SENT.includes(status)) return LiliBadgeType.RECOMMENDED;
    if (INVOICE_STATUS_GROUP_MAPPING.UNSENT.includes(status)) return LiliBadgeType.NEUTRAL;
    if (INVOICE_STATUS_GROUP_MAPPING.PAID.includes(status)) return LiliBadgeType.POSITIVE;
    if (INVOICE_STATUS_GROUP_MAPPING.CANCELED.includes(status)) return LiliBadgeType.CANCELLED;
    return LiliBadgeType.NEUTRAL;
  };

  return <LiliBadge id='statusBadge' title={getStatusBadgeText()} type={getType()} icon={getIcon()} />;
};
